import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: {
    principalRentOrOwn,
    principalIsPG,
    principalRent,
    applicantSameAsPrincipal,
  },
} = loanFormModel;

export class PrincipalRentValidation implements ValidationSchema {
  public name = principalRent.name;
  public label = principalRent.label;
  public dependsOn: string[] = [
    principalIsPG.name,
    principalRentOrOwn.name,
    applicantSameAsPrincipal.name,
  ];
  public type = 'number';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(
    principalIsPG: string,
    principalRentOrOwn: string,
    applicantSameAsPrincipal: string,
    schema
  ) {
    if (
      principalIsPG === 'Yes' &&
      applicantSameAsPrincipal === 'Yes' &&
      principalRentOrOwn === 'Rent'
    ) {
      return schema.required(principalRent.requiredErrorMsg);
    }
    return schema;
  }
}
export default new Validation(new PrincipalRentValidation());
